import BillingsTaxiDriverUpdateRequest, {
  BillingsTaxiDriverUpdateRequestContributionType,
  BillingsTaxiDriverUpdateRequestContribution,
  BillingsTaxiDriverUpdateRequestNode,
} from "../../../../api/raily/billings/taxi-driver/update/billings-taxi-driver-update.request";
import BillingsTaxiDriverUpdateParams, {
  BillingsTaxiDriverUpdateParamsContribution,
  BillingsTaxiDriverUpdateParamsContributionType,
  BillingsTaxiDriverUpdateParamsNode,
} from "./billings-taxi-driver-update-params";

const createContributionType = (
  type:
    | BillingsTaxiDriverUpdateParamsContributionType.BONUS_OTHER
    | BillingsTaxiDriverUpdateParamsContributionType.PENALTY_WRONG_ROUTE
    | BillingsTaxiDriverUpdateParamsContributionType.PENALTY_BEING_LATE
    | BillingsTaxiDriverUpdateParamsContributionType.PENALTY_INCOMPATIBLE_CAR
    | BillingsTaxiDriverUpdateParamsContributionType.PENALTY_OTHER,
):
  | BillingsTaxiDriverUpdateRequestContributionType.BONUS_OTHER
  | BillingsTaxiDriverUpdateRequestContributionType.PENALTY_WRONG_ROUTE
  | BillingsTaxiDriverUpdateRequestContributionType.PENALTY_BEING_LATE
  | BillingsTaxiDriverUpdateRequestContributionType.PENALTY_INCOMPATIBLE_CAR
  | BillingsTaxiDriverUpdateRequestContributionType.PENALTY_OTHER => {
  switch (type) {
    case BillingsTaxiDriverUpdateParamsContributionType.BONUS_OTHER:
      return BillingsTaxiDriverUpdateRequestContributionType.BONUS_OTHER;
    case BillingsTaxiDriverUpdateParamsContributionType.PENALTY_WRONG_ROUTE:
      return BillingsTaxiDriverUpdateRequestContributionType.PENALTY_WRONG_ROUTE;
    case BillingsTaxiDriverUpdateParamsContributionType.PENALTY_BEING_LATE:
      return BillingsTaxiDriverUpdateRequestContributionType.PENALTY_BEING_LATE;
    case BillingsTaxiDriverUpdateParamsContributionType.PENALTY_INCOMPATIBLE_CAR:
      return BillingsTaxiDriverUpdateRequestContributionType.PENALTY_INCOMPATIBLE_CAR;
    case BillingsTaxiDriverUpdateParamsContributionType.PENALTY_OTHER:
      return BillingsTaxiDriverUpdateRequestContributionType.PENALTY_OTHER;
  }
};

const createContribution = (
  contribution: BillingsTaxiDriverUpdateParamsContribution,
): BillingsTaxiDriverUpdateRequestContribution => {
  switch (contribution.type) {
    case BillingsTaxiDriverUpdateParamsContributionType.BASE_AMOUNT_EXTERNAL_TAXI:
      return {
        type: BillingsTaxiDriverUpdateRequestContributionType.BASE_AMOUNT_EXTERNAL_TAXI,
        comment: contribution.comment,
        amount: contribution.amount,
        distance: contribution.distance,
      };
    case BillingsTaxiDriverUpdateParamsContributionType.BONUS_FAVORABLE_DISTANCE:
      return {
        type: BillingsTaxiDriverUpdateRequestContributionType.BONUS_FAVORABLE_DISTANCE,
        comment: contribution.comment,
        distance: contribution.distance,
        rate: contribution.rate,
      };
    case BillingsTaxiDriverUpdateParamsContributionType.CONTRACT_CORRECTION_RATE:
      return {
        type: BillingsTaxiDriverUpdateRequestContributionType.CONTRACT_CORRECTION_RATE,
        comment: contribution.comment,
        rate: contribution.rate,
      };
    case BillingsTaxiDriverUpdateParamsContributionType.BONUS_OTHER:
    case BillingsTaxiDriverUpdateParamsContributionType.PENALTY_BEING_LATE:
    case BillingsTaxiDriverUpdateParamsContributionType.PENALTY_INCOMPATIBLE_CAR:
    case BillingsTaxiDriverUpdateParamsContributionType.PENALTY_OTHER:
    case BillingsTaxiDriverUpdateParamsContributionType.PENALTY_WRONG_ROUTE:
      return {
        type: createContributionType(contribution.type),
        comment: contribution.comment,
        amount: contribution.amount,
      };
  }
};

const createContributions = (
  contributions: BillingsTaxiDriverUpdateParamsContribution[],
): BillingsTaxiDriverUpdateRequestContribution[] => {
  return contributions.map(createContribution);
};

const createNode = (
  node: BillingsTaxiDriverUpdateParamsNode,
): BillingsTaxiDriverUpdateRequestNode => {
  return {
    allowCharge: node.allowCharge,
    checkoutDate: node.checkoutDate,
    checkoutEventId: node.checkoutEventUuid,
    description: node.description,
    distance: node.distance,
    editableCoordinates: node.editableCoordinates,
    haltingTime: node.haltingTime,
    highwayCharge: node.highwayCharge,
    lat: node.lat,
    lon: node.lon,
    nodeId: node.nodeUuid,
    orderId: node.orderUuid,
    plannedDate: node.plannedDate,
    plannedDistance: node.plannedDistance,
    id: node.uuid,
  };
};

const createNodes = (
  nodes: BillingsTaxiDriverUpdateParamsNode[],
): BillingsTaxiDriverUpdateRequestNode[] => {
  return nodes.map(createNode);
};

const createRequest = (
  params: BillingsTaxiDriverUpdateParams,
): BillingsTaxiDriverUpdateRequest => {
  return {
    billingContributions: createContributions(params.billingContributions),
    billingNodes: createNodes(params.billingNodes),
    billingUuid: params.billingUuid,
  };
};

const billingsTaxiDriverUpdateParamsFactory = {
  createRequest,
};

export default billingsTaxiDriverUpdateParamsFactory;
